import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { VALUE_BREAKDOWN_DETAILS } from "../keys";
import { format } from "date-fns";

const useValueBreakdownDetails = ({
  channels = [],
  markets = [],
  rights = [],
  page = 1,
  perPage = 50,
  sortBy = "date",
  sortOrder = "desc",
}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate && (channels.length > 0 || markets.length > 0 || rights.length > 0));

  let since;
  let until;
  if (date.startDate && date.endDate) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [
      VALUE_BREAKDOWN_DETAILS,
      tenant.id,
      channels,
      markets,
      rights,
      startDate,
      endDate,
      page,
      perPage,
      sortBy,
      sortOrder,
    ],
    queryFn: () =>
      ApiService.getSponsorValueBreakdownDetails(
        since,
        until,
        channels,
        markets,
        rights,
        page,
        perPage,
        sortBy,
        sortOrder
      ),
    select: (response) => response.data,
    enabled,
    keepPreviousData: false, // Don't show stale data when filters change
    placeholderData: {
      data: {
        data: [],
        meta: {
          total: 0,
          per_page: perPage,
          current_page: page,
          last_page: 0,
        },
        filters: {
          channels: [],
          markets: [],
          rights: [],
        },
      },
    },
  });
};

export default useValueBreakdownDetails;
